import logo from "./nfid-logo-playground.svg"

export const NFIDLogoPlayground = () => (
  <img src={logo} alt="NFID Wallet Playground" />
)
